import { Heading, HeadingProps } from "@chakra-ui/react";
import React, { forwardRef } from "react";

export const WidgetTitle = forwardRef<HeadingProps, "h4">(({ children, ...props }: any, ref) => (
    <Heading mx={{ base: "-15px", sm: "0" }} fontSize="14px" as="h4" borderLeft="6px solid #D1E6FF" pl="13px" lineHeight="24px" ref={ref as any} {...props}>
        {children}
    </Heading>
));